import * as React from 'react';

function GBIcon(props) {
  return (
    <svg width={60} height={24} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect width={36} height={24} rx={4} fill='#4EB862' />
      <path
        d='M5.81 12.592c0-1.86.624-3.42 1.872-4.68 1.26-1.272 2.832-1.908 4.716-1.908 1.92 0 3.504.54 4.752 1.62l-1.152 1.728c-.396-.36-.912-.654-1.548-.882a5.478 5.478 0 00-1.854-.342c-1.38 0-2.46.42-3.24 1.26-.768.84-1.152 1.884-1.152 3.132 0 1.356.408 2.46 1.224 3.312.816.84 1.836 1.26 3.06 1.26 1.212 0 2.28-.444 3.204-1.332v-1.494H13.73v-1.998h4.05V19H15.8v-.612l.018-.54h-.036c-.42.408-.966.738-1.638.99-.66.252-1.35.378-2.07.378-1.74 0-3.222-.612-4.446-1.836-1.212-1.236-1.818-2.832-1.818-4.788zM20.33 19V6.22h4.553c1.188 0 2.142.294 2.862.882.732.576 1.098 1.38 1.098 2.412 0 .6-.138 1.14-.414 1.62-.276.48-.654.852-1.134 1.116v.036c.672.192 1.182.57 1.53 1.134.36.564.54 1.188.54 1.872 0 1.212-.42 2.136-1.26 2.772-.84.624-1.89.936-3.15.936H20.33zm2.321-7.56h2.25c.492 0 .876-.15 1.152-.45.288-.312.432-.708.432-1.188 0-.468-.144-.846-.432-1.134-.276-.3-.672-.45-1.188-.45h-2.214v3.222zm0 5.562h2.484c.576 0 1.026-.168 1.35-.504.336-.348.504-.798.504-1.35 0-.54-.168-.978-.504-1.314-.324-.348-.774-.522-1.35-.522h-2.484v3.69z'
        fill='#fff'
      />
    </svg>
  );
}

export default GBIcon;
